import { SIZE } from '../../../../constants/size'
import { FormModal } from '../../../Form'

import {
  BUILDING_GROUP_ACTION_REMOVE_GROUP_INITIAL_VALUES,
  QA_NAME_REMOVE_BUILDING_GROUP_MODAL,
} from './BuildingGroupsRemoveActionModal.constants'
import { FormFields } from './FormFields'

function BuildingGroupsRemoveActionModal({
  confirmationTextKey,
  formTitle = 'Modal.RemoveBuildingGroupTitleKey',
  onCloseModal,
  onSubmit,
}) {
  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_REMOVE_BUILDING_GROUP_MODAL,
      }}
      formBodyProps={{
        submitButtonText: 'Modal.DeleteBtnKey',
      }}
      formFieldsProps={{ confirmationTextKey }}
      formTitle={formTitle}
      initialValues={BUILDING_GROUP_ACTION_REMOVE_GROUP_INITIAL_VALUES}
      onClose={onCloseModal}
      onSubmit={onSubmit}
    />
  )
}

export default BuildingGroupsRemoveActionModal
